/* @flow */
import {Observable} from 'rxjs';
import {combineEpics} from 'redux-observable';
import createDebugger from 'debug';
import {both, complement, compose, curry, equals, head, identity, join, map, pathOr, prop,} from 'ramda';
import {CHAT_INVITE_STATUS_UPDATE, JOIN_COMMUNITY_CHAT_CHANNEL,} from './action-types.js';
import {SLACK_COMMUNITY_CHAT_WORKSPACE_URL, USER_STATUSES_FOR_SLACK_COMMUNITY} from './constants';

const debug = createDebugger('app:modules:chat:epics'); // eslint-disable-line no-unused-vars

const joinSlackCommunityChatEpic = (action$, store, {ajax}) =>
  action$.ofType(JOIN_COMMUNITY_CHAT_CHANNEL)
    .map(prop('payload'))
    .mergeMap(resendInviteEmail =>
      ajax.post(`/services/slack/invite-user?resend=${resendInviteEmail ? 'true' : 'false'}`)
        .map(({response}) => ({
          type: CHAT_INVITE_STATUS_UPDATE,
          payload: {...response, resendAlreadyClicked: resendInviteEmail},
        }))
        .catch(err => Observable.of(
          {
            type: CHAT_INVITE_STATUS_UPDATE,
            payload: {status: USER_STATUSES_FOR_SLACK_COMMUNITY.ERROR},
          }),
        ));

const launchSlackCommunityChatEpic = (action$) =>
  action$.ofType(CHAT_INVITE_STATUS_UPDATE)
    .map(prop('payload'))
    .filter(({status}) => status === USER_STATUSES_FOR_SLACK_COMMUNITY.USER_ALREADY_EXISTS)
    .do(() => {
      const win = window.open(SLACK_COMMUNITY_CHAT_WORKSPACE_URL, '_blank');
      win.focus();
    })
    .ignoreElements(); // Don't worry about the result. Fire and forget

export default combineEpics(
  joinSlackCommunityChatEpic,
  launchSlackCommunityChatEpic,
);



// WEBPACK FOOTER //
// ./src/app/modules/chat/epics.js